<template>
  <div class="APIHomepage_more_detail">
    <div class="more-table-in">
      <div class="detail-breadcrumb">
        <span>
          Data Library / Website Navigation /
          <span class="fromitem">{{ apiName }}</span>
        </span>
      </div>
      <div class="detail-info-header">
        <div class="info-title">{{ apiName }}</div>
        <div class="info-content borderbottom">
          <div class="flex_center_bettwen">
            <div>
              <div class="api-tag">
                <el-tag
                  v-for="(i, idx) in labelList"
                  :key="idx"
                  class="flex_center_start tag"
                  :type="idx == 0 ? 'warning' : ''"
                >
                  <img
                    v-if="idx == 0"
                    src="@/assets/images/dataServices/dataLibrary-img/tag.png"
                    alt=""
                  />
                  {{ i.labelName }}
                </el-tag>
              </div>
              <div class="api-date-version">
                Effective Date: {{$formatDateTime(apiInfo.updateTime, "yyyy-MM-dd hh:mm:ss") }} | Author: Product Team
              </div>
            </div>
            <el-button
              type="primary"
              class="api-download-btn"
              @click="DownloadnClick"
            >
              Download
            </el-button>
          </div>
        </div>
      </div>
      <div
        class="detail-info-block"
      >
        <div class="info-title">{{ apiInfo.requestParams }}</div>
        <div class="info-content">
          <pre class="info-desc prewrap">{{ apiInfo.requestBody }}</pre>
        </div>
      </div>
      </div>
  </div>
</template>

<script>
import {
  getApiDataApiItemById,
  downLoadFileByItemId,
} from "@/api/dataServicesApi";
import { downloadFromBase64 } from "@/utils/date";
export default {
  name: "WebsiteNavigationDetail",
  props: [],
  data() {
    return {
      apiName: "", //二级名称
      apiInfo: {},
      labelList: [
        { labelName: "REST API" },
        { labelName: "Batch Processing" },
        { labelName: "JSON" },
      ],
    };
  },
  components: {},
  computed: {},
  watch: {},
  created() {
    this.getApiDataApiItemByIdList();
  },
  mounted() {},
  methods: {
    // 获取详情数据
    async getApiDataApiItemByIdList() {
      console.log("this.$route", this.$route);
      this.id = this.$route.query.id;
      let res = await getApiDataApiItemById(`?id=${this.id}`);
      console.log("res---", res, res.code);
      if (res.code == 200) {
        this.apiInfo = JSON.parse(JSON.stringify(res.data));
        this.apiName = this.apiInfo.apiName;
        console.log("this.apiInfo", this.apiInfo);
      }
    },
    // 展示json对象
    formattedJson(data) {
      try {
        let obj = JSON.parse(data);
        return JSON.stringify(obj, null, 2); // 2 个空格缩进
      } catch (e) {
        return "Invalid JSON";
      }
    },
    DownloadnClick() {
      let params = {
        apiItemId: this.apiInfo.id,
        fileType: "pdf",
      };
      downLoadFileByItemId(params).then((res) => {
        if (res.code == 200) {
          // 截取文件后缀名 查看属于什么文件
          let fileType = res.msg.split(".").pop().toLowerCase();
          var downloadType = "";
          if (fileType == "pdf") {
            downloadType = "application/pdf";
          }
          downloadFromBase64(res.data, downloadType, res.msg);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style scoped>
@import '../../../assets/css/DataLibraryDetail.css';

</style>
